import React from 'react';

import Large from './cards/large';
import Small from './cards/small';

const Card = ({ size = 'large', ...props }) => {
  if (size === 'large') {
    return <Large {...props} />;
  } else if (size === 'small') {
    return <Small {...props} />;
  } else {
    return <h1>Unknown Card Size</h1>;
  }
};

export default Card;
